<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-tabs type="border-card">
        <el-tab-pane label="功能描述:">1、杜一生app的通用对账底层，随意选择需要对账的模块，下载文件</el-tab-pane>
      </el-tabs>
      <el-descriptions :column="1" class="mt20">
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('tuitionListExport')">充值收款收账</el-button>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('ExportCustomerOrderReconciliation')">订单对账</el-button>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('EEForMeetSignUp')">报名会议对账</el-button>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('ExportCourseOrderReconciliation')">课程订单对账</el-button>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('ExportOrderAfterExport')">售后对账</el-button>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-button type="primary" @click="handleExport('allPaymentExport')">收款明细对账（全量）</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  created() {
  },
  methods: {
    handleExport(code) {
      this.$router.push("/export/list?code=" + code)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-button--primary {
  width: 450px;
}
::v-deep .el-descriptions-item__label.has-colon:after{
  content: '';
}
</style>
